import { SelectItem } from "primeng/api";
import { toDate } from "../classes/utils";

export interface LookupItem extends SelectItem {
  properties: any;
}

export class ObjectHistoryModel {
    id: number;
    date: string;
    user: string;
    data: string;
    dataObject: ObjectHistoryDataModel;
}

export class ObjectHistoryDataModel {
    Id: number;
    Name: string;
    Changes: Array<FieldHistoryModel>;
}

export class FieldHistoryModel {
    Name: string;
    OldValue: string;
    NewValue: string;
    Added: Array<ObjectHistoryModel>;
    Updated: Array<ObjectHistoryModel>;
    Removed: Array<ObjectHistoryModel>;
}

export class ObjectHistoryFieldMetadata {
    fieldName: string;
    displayName: string;

    constructor(fieldName: string, displayName: string) {
        this.fieldName = fieldName;
        this.displayName = displayName;
    }
}

export class TemplateAssignment {
    id: number;
    programDetailId: number;
    sectionTemplateId: number;
    sectionTemplateVersion: number;
    sectionTemplateInstanceSetId: number;

    name: string;
    type: string;
    label: string;
    requiresApproval: boolean;
    blockingStatus: SelectItem;
    hideFromPec: boolean;
    canPecEdit: boolean;
  
    isApproved: boolean = false;
    sortOrder: number;
    taskDeadlineDate: Date;
    taskDeadlineNotes: string;
  
    modifiedBy: string;
    modifiedOn: Date;

    applicationStatuses: Array<SelectItem> = [];
  
    public static formatDates(model: TemplateAssignment) {
      model.taskDeadlineDate = toDate(model.taskDeadlineDate);
    }
}

export class HistoryFilter {
    users: Array<string>;
    dateFrom: Date | null;
    dateTo: Date | null;
    fields: Array<string>;
}

export enum ObjectHistoryType {
    Agreement = 'agreement',
    FormField = 'formfield',
    ProgramDetail = 'programdetail',
    Program = 'program',
    Scholarship = 'scholarship',
    SectionTemplate= 'sectiontemplate',
    User = 'user',
    TemplateTask = 'templatetask',
    ApplicationProgressText = 'applicationprogresstext',
    ProgramType = 'programType'
}

export interface StickyTableSelectorConfig {
    selector: string;
    multiple?: boolean;
}